import classNames from 'classnames'
import React, { ReactNode } from 'react'

type Intent = 'positive' | 'negative'

export const ChartTag = ({ children, intent }: { children: ReactNode; intent: Intent }) => {
    return (
        <div
            style={{ padding: '2px 5px', borderRadius: 5 }}
            className={classNames(
                'inline-flex',
                'gap-2.5',
                'text-xs',
                'font-semibold',
                intent == 'positive'
                    ? 'bg-mjGreen-100 text-mjGreen-600'
                    : 'bg-mjRed-100 text-mjRed-500',
            )}
        >
            {children}
        </div>
    )
}
